import { Fancybox } from '@fancyapps/ui';
import Faqs from '../../../frontend/blocks/faqs/faqs.js';
import HeaderScroll from './components/HeaderScroll.js';
import Carousel from './components/Carousel.js';
import MobileMenu from './components/MobileMenu.js';
import FooterToggle from './components/FooterToggle.js';
import Tabs from './components/Tabs.js';
import GformUpload from './components/GformUpload.js';
import SmoothScroll from './components/SmoothScroll.js';
import NumberCounter from './components/NumberCounter.js';
import IconGridSlider from '../../../frontend/blocks/icon-grid/icon-grid';
import FullWidthImageSlider from '../../../frontend/blocks/full-width-image-video/full-width-image-video';
import ImageTextTwoColSlider from '../../../frontend/blocks/image-text-two-col/image-text-two-col';
import ImageTextThreeColSlider from '../../../frontend/blocks/image-text-three-col/image-text-three-col';
import ImageTextFourColSlider from '../../../frontend/blocks/image-text-four-col/image-text-four-col';
import InteractivePageCards from '../../../frontend/blocks/interactive-page-cards/interactive-page-cards';
import LatestStoriesSlider from '../../../frontend/blocks/latest-stories/latest-stories';
import NewsSlider from '../../../frontend/blocks/news/news';
import AppealsSlider from '../../../frontend/blocks/appeals/appeals';
import EventsSlider from '../../../frontend/blocks/events/events';
import TextImageSlider from '../../../frontend/blocks/text-image/text-image';
import Fundraisers from '../../../frontend/blocks/fundraisers/fundraisers';
import Tributes from '../../../frontend/blocks/tributes/tributes';
import FormPopup from './components/FormPopup';
import ToolTip from "./components/ToolTip";
import NewsCategories from "./components/NewsCategories";
import PopUp from './components/PopUp';
import QuoteSlider from '../../../frontend/blocks/quote-slider/quote-slider.js';
import Toggle from './components/Toggle.js';
import SubmenuOverlay from './components/SubmenuOverlay.js';

{
    const slider = document.querySelector('.carousel');

    if ( typeof slider != 'undefined' && slider ) {
        Carousel();
    }
}

{
    const tributes = document.querySelector('.tributes');

    if ( typeof tributes != 'undefined' && tributes ) {
        Tributes();
    }
}

{
    const fundraisers = document.querySelector('.fundraisers');

    if ( typeof fundraisers != 'undefined' && fundraisers ) {
        Fundraisers();
    }
}


{
    const quoteSlider = document.querySelector('[data-quote-slider]');
    if (typeof quoteSlider  != "undefined" && quoteSlider  != null) {
        QuoteSlider(quoteSlider);
    }
}

{
    const header = document.querySelector('.header');

    if ( typeof header != 'undefined' && header ) {
        HeaderScroll();
        SubmenuOverlay();
    }
}

{
    const faqs = document.querySelector('[data-question]');

    if ( typeof faqs != 'undefined' && faqs ) {
        Faqs();
    }
}

{
    const faqs_two = document.querySelector('[data-two-question]');

    if ( typeof faqs_two != 'undefined' && faqs_two ) {
        FaqsTwo();
    }
}

{
    const mobile_menu = document.querySelector('.mobile-menu');

    if ( typeof mobile_menu != 'undefined' && mobile_menu ) {
        MobileMenu();
    }
}

{
    const footer_toggle = document.querySelector('[data-footer-toggle]');

    if (typeof footer_toggle != 'undefined' && footer_toggle) {
        FooterToggle();
    }
}

{
    const tabs = document.querySelector('[data-tabs]');

    if (typeof tabs != "undefined" && tabs != null) {
        Tabs();
    }
}

{
    if (typeof gform != "undefined" && gform != null) {
        GformUpload();
    }
}

{
    const anchorLink = document.querySelector('[data-smooth-scroll]');
    
    if (typeof anchorLink != "undefined" && anchorLink != null) {
        SmoothScroll(anchorLink);
    }
}

{
    const numberCounter = document.querySelector('[num]');
    if (typeof numberCounter != "undefined" && numberCounter != null) {
        NumberCounter();
    }
}

{
    const iconGridSlider = document.querySelector('[data-icon-grid-col]');

    if (typeof iconGridSlider  != "undefined" && iconGridSlider  != null) {
        IconGridSlider(iconGridSlider);
    }
}

{
    const fullWidthImageSlider = document.querySelector('.full-width-image-video__images--slider');

    if (typeof fullWidthImageSlider != "undefined" && fullWidthImageSlider != null) {
        FullWidthImageSlider(fullWidthImageSlider);
    }
}

{
    const imageTextTwoColSlides = document.querySelector('[data-image-text-two-col]');

    if (typeof imageTextTwoColSlides  != "undefined" && imageTextTwoColSlides  != null) {
        ImageTextTwoColSlider(imageTextTwoColSlides);
    }
}

{
    const imageTextThreeColSlides = document.querySelector('[data-image-text-three-col]');

    if (typeof imageTextThreeColSlides  != "undefined" && imageTextThreeColSlides  != null) {
        ImageTextThreeColSlider(imageTextThreeColSlides);
    }
}

{
    const imageTextFourColSlides = document.querySelector('[data-image-text-four-col]');

    if (typeof imageTextFourColSlides  != "undefined" && imageTextFourColSlides  != null) {
        ImageTextFourColSlider(imageTextFourColSlides);
    }
}

{
    const interactivePageCards = document.querySelectorAll('.interactive-page-cards');

    if (interactivePageCards.length) {
        interactivePageCards.forEach((block) => {
            InteractivePageCards(block);
        });
    }
}

{
    const latestStoriesSlides = document.querySelector('[data-latest-stories-col]');

    if (typeof latestStoriesSlides  != "undefined" && latestStoriesSlides  != null) {
        LatestStoriesSlider(latestStoriesSlides);
    }
}

{
    const newsSlides = document.querySelector('[data-news-col]');

    if (typeof newsSlides  != "undefined" && newsSlides  != null) {
        NewsSlider(newsSlides);
    }
}

{
    const appealsSlides = document.querySelector('[data-appeals-col]');

    if (typeof appealsSlides  != "undefined" && appealsSlides  != null) {
        AppealsSlider(appealsSlides);
    }
}

{
    const eventsSlides = document.querySelector('[data-events-col]');

    if (typeof eventsSlides  != "undefined" && eventsSlides  != null) {
        EventsSlider(eventsSlides);
    }
}

{
    const textImageSlider = document.querySelector('.text-image__images--slider');

    if (typeof textImageSlider != "undefined" && textImageSlider != null) {
        TextImageSlider();
    }
}

{
    const formPopups = document.querySelector('[data-form-popup]');
    if (typeof formPopups != "undefined" && formPopups != null) {
        FormPopup();
    }
}

{
    let AdaptableLogo = document.querySelector('.footer__adaptLogo');
    if (typeof AdaptableLogo != "undefined" && AdaptableLogo != null) {
      ToolTip()
    }
}

{
    const newsCategories = document.querySelector('[data-archive-content]');

    if (typeof newsCategories  != "undefined" && newsCategories  != null) {
        NewsCategories(newsCategories);
    }
}

{
    const popUpElement = document.querySelector('.popup');
  
    if (typeof popUpElement != 'undefined' && popUpElement != null) {
      const popUpClosed = localStorage.getItem('popUpSeen');
      popUpClosed ? null : PopUp();
    }
}

{
    const searchPopupButton = document.querySelector('[data-search-toggle]');
  
    if (typeof searchPopupButton != 'undefined' && searchPopupButton != null) {
        Toggle('search');
    }
}

{
    const mobileMenuButton = document.querySelector('[data-mobile-toggle]');
  
    if (typeof mobileMenuButton != 'undefined' && mobileMenuButton != null) {
        Toggle('mobile');    
    }
}
